﻿import {Controller} from "./helpers/controller";

export class ReadingTimeControl extends Controller {
    
    private articleSelector: string = '';
    
    constructor(element: HTMLElement) {
        super(element);
        this.articleSelector = $(element).data().readingtime;
        
        const text = $(this.articleSelector).get()[0].innerText;
        const wpm = 225;
        const words = text.trim().split(/\s+/).length;
        const time = Math.ceil(words / wpm);
        
        $(element).html(`${time} mins read`);
    }
}